<div *ngFor="let file of resources">
  <app-resource [resource]="file"
                (resourceClicked)="resourceClicked.emit(file)">
  </app-resource>
</div>
